export default __webpack_public_path__ + "static/media/oe-3-rMAX.d1b462dd.jpg";